module.exports = __webpack_public_path__ + "static/group-3@3x-828a1bff300a6c1a1d55c2941a28ad6e.png";